import React, { Component } from "react";
import PropTypes from "prop-types";

import BottomNavbar from "./BottomNavbar";
import { bottomNavbarHeight } from "./styleConstants";

class LayoutComponent extends Component {
  constructor(props) {
    super(props);

    this.toggleSidebar = this.props.toggleSidebar.bind(this);
  }

  render() {
    console.log("this.context");
    console.log(this.context);
    return (
      <div>
        <div style={style.content}>{this.props.children}</div>
        <BottomNavbar
          router={this.context.router}
          partyName={this.props.partyName}
        />
      </div>
    );
  }
}

LayoutComponent.propTypes = {
  sidebarIsVisible: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  partyName: PropTypes.string,
};

LayoutComponent.contextTypes = {
  router: PropTypes.object,
};

const style = {
  content: {
    marginBottom: `${bottomNavbarHeight}px`,
  },
};

export default LayoutComponent;
